import React, { memo } from 'react';
import { Clipboard, CheckCircle } from 'lucide-react';

/**
 * Copy button component for messages
 * Shows a clipboard icon that changes to checkmark when content is copied
 */
const CopyButton = memo(({ messageId, copiedMessageId, onCopy }) => (
  <button 
    onClick={onCopy}
    className="absolute top-3 right-3 p-2 opacity-0 group-hover:opacity-100 transition-all duration-200 bg-white/80 dark:bg-neutral-800/80 backdrop-blur-sm rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-700 z-10 shadow-sm"
    title="Copy to clipboard"
    aria-label="Copy to clipboard"
  >
    {copiedMessageId === messageId ? (
      <CheckCircle size={16} className="text-semantic-success" />
    ) : (
      <Clipboard size={16} className="text-neutral-600 dark:text-neutral-400" />
    )}
  </button>
));

CopyButton.displayName = 'CopyButton';

export default CopyButton;